import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { faqData } from '../mock/spanglishData';

const FAQ = () => {
  const colors = [
    'bg-pink-50 border-pink-200',
    'bg-purple-50 border-purple-200',
    'bg-blue-50 border-blue-200',
    'bg-yellow-50 border-yellow-200',
    'bg-green-50 border-green-200',
    'bg-pink-50 border-pink-200'
  ];

  return (
    <section id="faq" className="py-20 bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-purple-600 mb-4">
            {faqData.title}
          </h2>
          <p className="text-xl text-purple-600">
            {faqData.subtitle}
          </p>
        </div>

        {/* Accordion */}
        <div className="bg-white rounded-3xl shadow-xl border-4 border-purple-300 p-6">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqData.questions.map((item, index) => (
              <AccordionItem 
                key={item.id} 
                value={`item-${item.id}`}
                className={`${colors[index % colors.length]} border-3 rounded-2xl px-4 transition-all duration-300 hover:shadow-lg`}
              >
                <AccordionTrigger className="text-left hover:no-underline py-5">
                  <span className="font-bold text-purple-700 text-lg pr-4">
                    {item.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-gray-700 pb-5 leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Additional Help */}
        <div className="mt-12 text-center bg-gradient-to-r from-yellow-100 to-pink-100 p-6 rounded-3xl border-3 border-purple-200">
          <p className="text-purple-700 font-semibold mb-4">
            Can't find the answer you're looking for?
          </p>
          <button 
            className="text-purple-600 font-bold hover:text-pink-600 transition-colors duration-300 underline text-lg"
            onClick={() => {
              const contactSection = document.getElementById('contact');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            Contact us directly →
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
